<template>
	<div>
		<el-dialog title="打印" :visible.sync="kaiqi">
			 <div id="printTest">
				打印内容
			 </div>
			  <div slot="footer" class="dialog-footer">
			     <el-button @click="kaiqi= false">取 消</el-button>
			     <el-button type="primary" v-print="'#printTest'" @click="kaiqi= false">打 印</el-button>
			   </div>
		</el-dialog>  
	</div>
</template>

<script>
	let that;

	export default {
		name: 'dayin',
		data() {
			return {
				kaiqi:false
			}
		},
		props: {},
	

	}
</script>

<style>


</style>
